import axios from "axios";
/**
 * Type guard to check if error is an Axios error with API error response
 */
export function isAxiosErrorResponse(error) {
    return (axios.isAxiosError(error) &&
        error.response !== undefined &&
        error.response.data !== undefined &&
        typeof error.response.data === "object");
}
/**
 * Extract API error code from an error object
 * @param error - The error to extract error code from
 * @returns The error code if found, undefined otherwise
 */
export function getApiErrorCode(error) {
    if (isAxiosErrorResponse(error)) {
        return error.response?.data?.errorCode;
    }
    return undefined;
}
/**
 * Check if error matches a specific error code
 * @param error - The error to check
 * @param errorCode - The error code to match against
 * @returns True if error code matches, false otherwise
 */
export function isApiErrorCode(error, errorCode) {
    const code = getApiErrorCode(error);
    return code !== undefined && code === errorCode;
}
/**
 * Get the full API error response data
 * @param error - The error to extract response from
 * @returns The API error response data if available, undefined otherwise
 */
export function getApiErrorResponse(error) {
    if (isAxiosErrorResponse(error)) {
        return error.response?.data;
    }
    return undefined;
}
